// extracted by mini-css-extract-plugin
export default {"iconsContainer":"project_iconsContainer__ft8j-","date":"project_date__jfqT3","filtersApplied":"project_filtersApplied__9yOKn"};